import React from 'react'
import './Components.css'

const Header: React.FC = ({ children }) => {
  return <h2 className='h1-rem mb-4'> {children} </h2>
}
export default Header
